import { WorkflowStatus, WorkflowStatusListType } from 'typings/enums';

export const workflowStatusFromListTypeMap = new Map<string, WorkflowStatus>([
    [WorkflowStatusListType.Open, WorkflowStatus.Open],
    [WorkflowStatusListType.InProgress, WorkflowStatus.InProgress],
    [WorkflowStatusListType.Pending, WorkflowStatus.PendingReview],
    [WorkflowStatusListType.Approved, WorkflowStatus.Approved]]);

export const listTypeFromWorkflowStatusMap = new Map<WorkflowStatus, string>([
    [WorkflowStatus.Open, WorkflowStatusListType.Open],
    [WorkflowStatus.InProgress, WorkflowStatusListType.InProgress],
    [WorkflowStatus.PendingReview, WorkflowStatusListType.Pending],
    [WorkflowStatus.Approved, WorkflowStatusListType.Approved]]);